import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Beat } from "../../../plugins/spinners.plugin";
import Input from "../../inputs/inputs";
import Button from "../../buttons/buttons";
import { cleanInput } from "../../../helpers/cleanInput";
import Warning from "../../../assets/images/icons/warning.svg";
import { filterSubscriptionFoodAction } from "../../../redux/packageSubscriptionFoodOrder/packageSubscriptionFoodOrderAction";

export default function FilterUserPackageOrdersDropDown(props) {
  const { payLoad, setPayLoad, isFilterOpen, setFilterState, page } = props;
  const dispatch = useDispatch();
  const { filtering } = useSelector((state) => state.packageSubscriptionFoodOrder);

  const [errorMsg, setErrorMsg] = useState(false);
  const [data, setData] = useState({
    start_date: "",
    end_date: "",
    order_paid: "",
    status: '',
  });
  const {
    start_date,
    end_date,
    order_paid,
    status
  } = data;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleReset = async () => {
    setData({
      start_date: "",
      end_date: "",
      order_paid: "",
      status: '',
    });
    const resetPayload = { end_date: new Date() };
    setPayLoad(resetPayload);
    await dispatch(
      filterSubscriptionFoodAction(resetPayload, page)
    );
    setFilterState(!isFilterOpen);
  };

  const handleSubmit = async () => {
    cleanInput(data);
    let newData = { ...payLoad, ...data };
    if (
      order_paid ||
      status ||
      start_date ||
      end_date
    ) {
      setErrorMsg(false);
      try {
        setPayLoad(newData);
        const response = await dispatch(
          filterSubscriptionFoodAction(newData, 1)
        );
        if (response?.status === "success") {
          setFilterState(!isFilterOpen);
        }
      } catch (error) {
        console.log(error);
        setFilterState(!isFilterOpen);
      }
    } else {
      setErrorMsg(true);
    }
  };

  return (
    <div data-test="">
      <form className="py-5 mt-4 px-5">
        <div className="grid grid-cols-1">

          <Input.Select
            title={"Order Paid"}
            htmlFor={"order_paid"}
            name={"order_paid"}
            value={order_paid}
            onChange={handleChange}
          >
            <option>Select payment status</option>
            <option value={"1"}>Paid</option>
            <option value={"0"}>Unpaid</option>
          </Input.Select>

          <Input.Select
            title={"Order Status"}
            htmlFor={"status"}
            name={"status"}
            value={status}
            onChange={handleChange}
          >
            <option>Select status</option>
            <option value={"shipped"}>Shipped</option>
            <option value={"unshipped"}>Unshipped</option>
            <option value={"delivered"}>Delivered</option>
            <option value={"closed"}>Closed</option>
            <option value={"queued"}>Queued</option>
          </Input.Select>

          <Input.DatePicker
            title={"Start Date"}
            name="start_date"
            id="start_date"
            htmlFor={"start_date"}
            defaultValue={start_date}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            onChange={handleChange}
            selected
          />
          <Input.DatePicker
            title={"End Date"}
            name="end_date"
            id="end_date"
            htmlFor={"end_date"}
            defaultValue={end_date}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            onChange={handleChange}
            selected
          />
        </div>
        <div className="py-8 grid grid-cols-2 gap-6 text-center">
          <Button.Secondary
            disabled={filtering}
            title={"Reset"}
            className="px-4"
            onClick={handleReset}
            type="button"
          />
          <Button.Primary
            disabled={filtering}
            title={filtering ? <Beat color={"#ffffff"} /> : "Filter"}
            className="px-4"
            onClick={handleSubmit}
            type="button"
          />
        </div>
        {errorMsg && (
          <div className="flex gap-1 -mt-2">
            <img src={Warning} alt="warning" />
            <p>No value to filter by</p>
          </div>
        )}
      </form>
    </div>
  );
}
